import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Card, Modal, Map, HRSelect } from 'components';
import { Progress, Form, Input, InputNumber, DatePicker, Select,Upload  } from 'antd';
import AreaCharts from './components/AreaCharts';
import dayjs from 'dayjs';
import { SaveOutlined } from '@ant-design/icons';
import { FaBuilding, FaHouse, FaPen, FaUser } from 'react-icons/fa6';
import {ReactComponent as FacebookIcon} from 'assets/icons/facebook.svg';
import {ReactComponent as MailIcon} from 'assets/icons/mail.svg';
import {ReactComponent as WebIcon} from 'assets/icons/global.svg';
import { masterInstance } from 'utils/axios';
import PieCharts from 'modules/Dashboard/components/PieCharts';
import { Option } from "antd/es/mentions";
import { TbUser } from 'react-icons/tb';
import { FcConferenceCall } from 'react-icons/fc';
import ImgCrop from 'antd-img-crop';

const staticData = [47.91795272, 106.92232505]

function CompanyInfo() {
  const [ data, setData ] = useState({});
  const [ district, setDistrict] = useState([]);
  const [ province, setProvince ] = useState([]);
  const [ selectedProvince, setSelectedProvince] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ showModal, setShowModal ] = useState(false);
  const [ imageUrl, setImageUrl ] = useState();
  const [ file, setFile ] = useState();
  const [ form ] = Form.useForm();
  const [ product, setProduct] = useState([]);
  const [ employes, setEmployes] = useState([]);
  const [ emplenght, setEmpLenght] = useState([]);
  const [ branchlenght, setbranchlenght] = useState([]);
  const [ warehouselenght, setwarehouselenght] = useState([]);
  const [ location, setLocation] = useState([]);
  // const [ ProvinceValue, setProvinceValue] = useState([]);
  
  useEffect(() => {
    getData();
    // getAllProduct();
    getAllEmployes();
    getAllWarehoouses();
    getProvince();
    getAllBranch();
  },[]);

  useEffect(() => {
    form.setFieldsValue({
        name: data?.name,
        image: data?.logo,
        direction: data?.direction,
        descr: data?.descr,
        registration: data?.registration,
        slogan: data?.slogan,
        goal: data?.goal,
        mobile: data?.mobile,
        email: data?.email,
        website: data?.website,
        map: location,
        address: data?.address,
        established_date: dayjs(data?.established_date),
        provinceid: selectedProvince, // Assuming selectedProvince is an array of objects
        districtid: data?.districtid,
        committeeid: data?.committeeid,
    });
},[form, data,selectedProvince]);

  const getData = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:'company',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem("token")}`, 
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      setData(res.data);
      setLocation([res.data.lat, res.data.lng]);
      setSelectedProvince(res.data?.provinceid);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };

  const getAllProduct = () =>{
    axios({
      method: 'get',
      url: 'products'
    }).then((res) => {
      setProduct(res.data.length)
    }).catch((err) =>{

    })
  }

  const getAllEmployes = () =>{
    axios({
      method: 'get',
      url: 'users'
    }).then((res) => {
      const emp = [{ label: "Нийт ажилтан", value: res.data.length }];
      setEmpLenght(res.data.length);
      setEmployes(emp)
    }).catch((err) =>{

    })
  }
  const getAllWarehoouses = () =>{
    axios({
      method: 'get',
      url: 'warehouses'
    }).then((res) => {
      setwarehouselenght(res.data.length);
    }).catch((err) =>{

    })
  }

  const getAllBranch = () =>{
    axios({
      method: 'get',
      url: 'branches'
    }).then((res) => {
      setbranchlenght(res.data.length)
    }).catch((err) =>{

    })
  }
  const getProvince = () => {
    axios({
      method: 'get',
      url: 'provinces',
    }).then((res) => {
      let tmp = res.data.map((item) => ({
        value: parseInt(item.id),
        label: item.name,
      }));
      setProvince(tmp);
      // const prov = tmp.find((prov) => prov.value == data?.provinceid);
      }).catch((err) => {
      console.error("Error fetching provinces:", err);
    });
  };
  const getDistrict = () => {
    if (selectedProvince) {
        axios({
            method: 'get',
            url: `/districts?provinceid=${selectedProvince}`,
        })
        .then((res) => {
            let tmp = res.data.map((item) => ({
              value: parseInt(item.id),
              label: item.name,
            
              }));
            setDistrict(tmp);
        })
        .catch(() => {});
      }
};


useEffect(() => {
    getDistrict();
}, [selectedProvince]);

  const handleProvinceChange = (value) => {
    if(value){

      setSelectedProvince(value);
    }else {
      setSelectedProvince(data?.provinceid)
    }
    const prov = province.find((prov) => prov.value === data?.provinceid);
    if (prov) {
        form.setFieldsValue({ provinceid: prov.value });
    }
    
  };
  
  const handleSubmit = (values) => {
    setLoading(true);
    const formData = new FormData();
    let keys = Object.keys(values);
    keys.map((item) => {
      formData.append(item, values[`${item}`] || '');
    });
    // formData.set('image', imageUrl ? imageUrl : '');
    formData.append("image", values.image[0].originFileObj);
    formData.set('lat', values.map[0] ? values.map[0] : '[]');
    formData.set('lng', values.map[1] ? values.map[1] : '[]');
    formData.set('id', data.id);
      axios({
        method: 'post',
        url: `/company`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      }).then((res) => {
        getData();
        handleCancel();
      }).finally(() => {
        setLoading(false);
      })
  };
  const handleCancel = () => {
    setShowModal(false);
  };
  // const handleImageChange = (e) => {
  //   setImageUrl(e.target.files[0]);
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };
  const handleImageChange = ({ fileList }) => {
    form.setFieldsValue({ image: fileList }); 
  };
  return (
    <div className='grid grid-cols-10 gap-4'>
      <Card className='col-span-12 flex items-center justify-between h-[200px]'>
        <div className='flex items-center gap-6'>
          <img className='rounded-2xl w-32 h-32' alt='company-logo'
          src={`${process.env.REACT_APP_CDN_IMG}${data?.image}`}
          />
          <div>
            <h1 className='text-primary font-semibold text-[32px]'>{data?.name}</h1>
            <p className='text-grey-200 text-base font-normal'></p>
            <p className='text-grey-200 text-base font-normal'>Цахим шуудан : <span className='text-primary'>{data?.email}</span></p>
            <p className='text-grey-200 text-base font-normal'>Утас : <span className='text-primary'>{data?.mobile}</span></p>
          </div>
        </div>
        <div className='grid grid-cols-2 gap-6'>
            <div className='col-span-1'></div>
            <Button  
              type='primary'
              className='col-span-2'
              icon={<FaPen />}
              onClick={() => setShowModal(true)}
            >
              Засах
            </ Button>
          <div className='flex gap-4 col-span-2'>
            {/* <a target='_blank' href={data?.linkfb} className='p-2 text-primary bg-lightblue-200 rounded-lg cursor-pointer'><FacebookIcon /></a> */}
            <a target='_blank' href={`mailto:${data?.email}`} className='p-2 text-primary bg-lightblue-200 rounded-lg cursor-pointer'><MailIcon /></a>
            <a target='_blank' href={data?.website} className='p-2 text-primary bg-lightblue-200 rounded-lg cursor-pointer'><WebIcon /></a>
          </div>
        </div>
      </Card>
      <div className='col-span-4'>
        <Card className='col-span-3 mb-2 h-[400px] grid'>
            <div className='s'>
              <h1 className='text-2xl text-black-text font-medium'>Хаяг байршил</h1>
            <p className='text-grey-100 text-sm font-normal mb-2'>
              {province.find(item => item?.value === data?.provinceid)?.label},  {district.find(item => item?.value === data?.districtid)?.label}
            </p>
            </div>
            {/* <p className='text-grey-100 text-sm font-normal'>
              {data?.address}
            </p> */} 
            {
              location.length > 0 ? (
              <Map className={'h-[300px]'}
                value={location}
                center={location}
                onChange={() => {}} disabled={true} /> )
                : (
                    <svg aria-hidden="true" className="w-full h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                )
            }
             {/* <div className="flex justify-center items-center">
            {
              location.length > 0 ? (
              <Map className={'h-[300px]'}
                value={location}
                center={location}
                onChange={() => {}} disabled={true} /> )
                : (
                    <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                )
            }</div> */}
        </Card>
      </div>
      <div className='col-span-4'>
      <Card style={{ height: '400px', 
      // background: 'linear-gradient(to right, #f3f7f2, #638cf2)'
      background: 'white',
      }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl'>
          {/* <PieCharts colors={["#6B6B6B"]} legendHide={true} data={[{ label: 'test', value: 70}]} /> */}
          <div className='px-4 py-2 rounded-2xl bg-cardbg col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт ажилтан</p>
            </div>
            <span className='text-lg text-left font-semibold'>{emplenght}</span>
            </div>
          <FcConferenceCall style={{color:'white', marginLeft: '50px'}} size={70}/>
          <div className='px-4 py-2 rounded-2xl bg-cardbg col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт агуулах</p>
            </div>
            <span className='text-lg text-left font-semibold'>{warehouselenght}</span>
            </div>
            <FaHouse className='ml-[50px]' size={70}/>
          <div className='px-4 py-2 rounded-2xl bg-cardbg col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт салбар</p>
            </div>
            <span className='text-lg text-left font-semibold'>{branchlenght}</span>
            </div>
          <FaBuilding style={{color:'', marginLeft: '50px'}} size={70}/>
          </Card>
          
      </div>
      <div className='col-span-4 '>
          <Card style={{ height: '400px', 
          // background: 'linear-gradient(to right, #f3f7f2, #638cf2)'
          background: 'white',
            }}>
            <h1 className='font-semibold text-lg mb-4 '>Байгуулгын зорилго</h1>
            <div className='text-ellipsis'>
                <p>
                  {data.descr}
                </p>
              </div>
          </Card>
      </div>
      <div className='col-span-12 pl-2 h-[230px]'>
        <Card className='col-span-12 py-12 h-full'>
        <h1 className='mb-4 font-semibold text-lg'>
        Уриа
        </h1>
        <p>{data.slogan}</p>
        </Card>
      </div>

      <Modal 
        title={'Компанийн мэдээлэл засах'} 
        open={showModal} 
        onCancel={handleCancel}
        width={1050}
      >
        <Form
          onFinish={handleSubmit}
          form={form}
          layout='vertical'
        >
          <div className='w-full flex gap-4'>
            <div className='grid grid-cols-12 basis-1/3'>
             
              <Form.Item
                className='col-span-12 mb-0'
                label='Компаний нэр'
                name='name'
              >
                <Input className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Утас'
                name='mobile'
              >
                <Input className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='И-мэйл хаяг'
                name='email'
              >
                <Input className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Вэб хаяг'
                name='website'
              >
                <Input className='w-full'/>
              </Form.Item>
              <Form.Item className='col-span-12 mb-0 grid place-items-center' name='image'>
              <ImgCrop>
                  <Upload name="image" beforeUpload={() => false} type="drag" listType="picture" 
                    maxCount={1} 
                    onChange={handleImageChange}
                    >
                <div className='flex flex justify-center'>
                <img src={`${process.env.REACT_APP_CDN_IMG}${data?.logo}`} width={240} height={240} className='rounded-full'/>
                  </div>
                <div className='absolute bottom-0 left-0 right-0 top-0 rounded-full w-full h-full opacity-50 bg-black'></div>
                <div className='absolute bottom-0 left-0 right-0 top-0 grid place-items-center'>
                  <label className='border border-white rounded-2xl px-4 py-2 text-white text-xl font-medium cursor-pointer' for="logo">Зураг солих</label>
                </div>           
                </Upload>
              </ImgCrop>
              </Form.Item>
            </div>
            <div className='grid grid-cols-12  basis-2/3'>
              <Form.Item
                className='col-span-12 mb-0'
                label='Зорилго'
                name='descr'
              >
                <Input.TextArea className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Уриа'
                name='slogan'
              >
                <Input.TextArea className='w-full'/>
              </Form.Item>
              {/* <Form.Item
                className='col-span-12 mb-0'
                label='Аймаг'
                name='province'
              >
                <Input.TextArea className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Дүүрэг'
                name='district'
              >
                <Input.TextArea className='w-full'/>
              </Form.Item> */}
              <Form.Item
                    label="Аймаг"
                    name="provinceid"
                    rules={[{ required: true, message: 'Аймаг оруулна уу' }]}
                    className="col-span-6 mr-2"
                >
                    <Select
                        placeholder="Аймаг оруулна уу"
                        onChange={handleProvinceChange}
                        value={selectedProvince}
                        >
                        {province.map((opt) => (
                            <Option key={opt.value} value={opt.value} label={opt.label}
                            >
                                {opt.label}
                            </Option>
                              ))}
                    </Select>
                </Form.Item>
                <Form.Item
                  label="Дүүрэг"
                  name="districtid"
                  rules={[{ required: true, message: 'Дүүрэг оруулна уу' }]}
                  className="col-span-6 mb-1"
                >
                  <Select placeholder="Дүүрэг сонгох">
                    {district.map((dist) => (
                      <Option key={dist.value} value={dist.value} label={dist.label}>
                        {dist.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Хаяг'
                name='address'
              >
                <Input.TextArea className='w-full'/>
              </Form.Item>
              <Form.Item
                className='col-span-12 mb-0'
                label='Байршил'
                name='map'
              > 
                <Map 
                className={'h-[350px]'}
                />
            </Form.Item>
            </div>
          </div>
          <div className='col-span-12 flex justify-end items-center gap-2 mt-5'>
            <Button type='primary' onClick={() => form.submit()} loading={loading} icon={<SaveOutlined/>}>Хадгалах</Button>
            <Button onClick={handleCancel} disabled={loading}>Цуцлах</Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default CompanyInfo;